import React, { useState } from "react";
import "moment/locale/pt-br.js";
import Filtro from "./Filtro";
import Table from "./Table";
import ReportAcordeon from "../../../Components/ReportAcordeon";
import {
  getKnowledgeEvaluation,
  getDownloadReport,
  postDownloadReport,
} from "../../../../../services/NexiDigitalAPI";

const KnowledgeEvaluation = ({ index, expanded: _expanded }) => {
  const idReport = 11; // ALTERAR
  const name = "Relatório de Avaliação de Conhecimento";
  const description =
    "Este relatório traz as perguntas, respostas dos usuários e a nota obtida em avaliações de conhecimento e pré-testes (caso utilizado).";
  const [expanded, setExpanded] = useState(_expanded);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requestFilters, setRequestFilters] = useState({});

  const onClickExpanded = (value) => {
    setExpanded(value);
  };

  const actionFilter = async (values) => {
    if (expanded) {
      setLoading(true);

      const filter = { ...requestFilters, ...values };
      setRequestFilters(filter);

      getKnowledgeEvaluation(filter)
        .then((response) => {
          const responseData = response.data;

          console.log(responseData);
          setTotalRecords(responseData.totalRecords);
          setDados(responseData.result);
        })
        .finally(() => setLoading(false));
    }
  };

  const downloadEvent = async () => {
    if (loading) {
      return;
    }

    setLoading(true);
    const { idCompany, idTeam, nodeCode } = requestFilters;
    await postDownloadReport(idReport, { idCompany, idTeam, nodeCode });
    await requestDownloadReport();
  };

  const requestDownloadReport = async () => {
    try {
      const response = await getDownloadReport(idReport);
      const { status, fileUrl } = response?.data || {};

      if (status === "Waiting") {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return requestDownloadReport();
      }

      if (status === "Done" && fileUrl) {
        getFileReport(fileUrl);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getFileReport = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.click();
  };

  const filter = (
    <Filtro
      actionFilter={actionFilter}
      loading={loading}
      expanded={expanded}
      downloadEvent={downloadEvent}
    />
  );

  const result = (
    <Table
      dados={dados}
      loading={loading}
      actionFilter={actionFilter}
      totalRecords={totalRecords}
    />
  );

  return (
    <ReportAcordeon
      onClickExpanded={onClickExpanded}
      name={name}
      description={description}
      filter={filter}
      result={result}
      index={index}
      expanded={expanded}
    />
  );
};

export default KnowledgeEvaluation;
